/*
 * @Author: amy
 * @Date: 2021-04-21 10:44:30
 * @LastEditTime: 2022-06-20 17:35:21
 * @Description: file content
 */
import { request } from '@/utils/request'

// 获取项目树信息
export function getProjectTree(data) {
  return request({
    url: '/org/project-chose',
    method: 'POST',
    data
  })
}

// 根据项目查企业
export function getProjectFindEnt(params) {
  return request({
    url: '/project/find-ent',
    method: 'GET',
    params
  })
}

// 获取企业个性化配置
export function getEnterpriseConfigDetail(params) {
  return request({
    baseURL: 'initConfig',
    url: '/enterprise-config/get-ent-conf',
    method:'GET',
    params
  })
}

/**
 * 根据企业id获取企业设置的超时会话时间
 * @param {*} params 
 * @returns 
 */
 export function queryEnterpriseSesstionTime(params) {
  return request({
    baseURL: 'initConfig',
    url: '/enterprise-config/session-time/get',
    method:'GET',
    params
  })
}
/**
 * 根据企业id和应用id获取当前企业下该应用超时会话时间
 * @param {*} params 
 * @returns 
 */
export function getAppEnterpriseSesstionTime(params) {
  return request({
    baseURL: 'initConfig',
    url: '/enterprise-config/get-session-time',
    method:'GET',
    params
  })
}
/**
 * 获取企业选择器数据列表
 * @param {*} data 
 * @returns 
 */
export function queryEntList(data) {
  return request({
    url: '/ent/chose',
    method: 'POST',
    data
  })
}
/**
 * 获取项目列表数据
 * @param {*} data 
 * @returns 
 */
export function queryProjectList(data) {
  return request({
    url: '/org/project-chose/v3',
    method: 'POST',
    data
  })
}

// add by bb 20231018 登录的项目配置
export function accountSetLoginProject(data) {
  return request({
      url: '/account/account-set-login-project',
      method: 'post',
      data
  })
}